import { createUseStyles } from "react-jss";
import { NavLink } from "react-router";
import ContentWrapper from "../ContentWrapper";
import React from "react";

type link = {
  name: string;
  path: string;
  subLinks?: link[];
};

interface Props {
  logo: string;
  links: link[];
  copyLabel?: string;
}

const useStyles = createUseStyles({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "55px 0px",
    justifyContent: "space-between",
    backgroundColor: "#152E54",
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "@media (max-width: 1024px)": {
      padding: "50px 20px",
      flexDirection: "column",
      alignItems: "center",
    },
  },
  logo: {
    width: "140px",
  },
  navLinksWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  navLinks: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "@media (max-width: 1024px)": {
      marginTop: "30px",
    },
  },
  linkColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginRight: "20px",
  },
  link: {
    textDecoration: "none",
    borderRadius: "5px",
    padding: "10px 0px",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "14px",
  },
  subLink: {
    textDecoration: "none",
    padding: "5px 0px",
    color: "#fff",
    fontSize: "14px",
  },
  copy: {
    display: "flex",
    backgroundColor: "#002F6C",
    "& p": {
      color: "#fff",
      fontSize: "14px",
    },
    "@media (max-width: 1024px)": {
      textAlign: "center",
    },
  },
});

const Footer = ({ logo, links, copyLabel }: Props) => {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.root}>
        <ContentWrapper>
          <div className={classes.footer}>
            {logo && <img className={classes.logo} alt="logo" src={logo} />}
            <div className={classes.navLinksWrapper}>
              <div className={classes.navLinks}>
                {links.map((link) => {
                  return (
                    <div key={link.name} className={classes.linkColumn}>
                      <NavLink to={link.path} className={classes.link}>
                        {link.name}
                      </NavLink>
                      {link.subLinks?.map((sublink) => {
                        return (
                          <a
                            key={sublink.name}
                            className={classes.subLink}
                            href={sublink.path}
                          >
                            {sublink.name}
                          </a>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </ContentWrapper>
      </div>
      <div className={classes.copy}>
        <ContentWrapper>
          <p>{copyLabel}</p>
        </ContentWrapper>
      </div>
    </div>
  );
};

export default Footer;
